import { __assign, __awaiter, __extends, __generator, __read, __spread } from "tslib";
import Message from '../models/message';
import Resource from './resource';
import { sortBy, uniqBy } from 'lodash';
var MessagingModule = (function (_super) {
    __extends(MessagingModule, _super);
    function MessagingModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.conversation = [];
        _this.hasOlderMessages = function () { return _this.pagingOlder && _this.conversation.length < _this.pagingOlder.total; };
        _this.hasUnreadMessages = function () {
            var currentUser = _this.client.currentUser;
            return currentUser ? _this.conversation.some(function (m) { return m.to.id === currentUser.id && !m.readAt; }) : false;
        };
        return _this;
    }
    MessagingModule.prototype.fetchList = function (params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.get('/messages', { params: params }).then(function (_a) {
                            var data = _a.data;
                            return (__assign(__assign({}, data), { messages: data.data.map(function (m) {
                                    return new Message(m, _this.client);
                                }) }));
                        })];
                    case 1:
                        response = _a.sent();
                        this.updateConversation(response.messages);
                        if (params.before || !params.after) {
                            this.pagingOlder = response.paging;
                        }
                        else {
                            this.pagingLatest = response.paging;
                        }
                        return [2, response];
                }
            });
        });
    };
    MessagingModule.prototype.send = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var message;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http
                            .post('/messages', { body: body })
                            .then(function (_a) {
                            var data = _a.data.data;
                            return new Message(data, _this.client);
                        })];
                    case 1:
                        message = _a.sent();
                        this.conversation = this.conversation ? __spread(this.conversation, [message]) : [message];
                        return [2];
                }
            });
        });
    };
    MessagingModule.prototype.updateConversation = function (messages) {
        var newMessages = Array.isArray(messages) ? messages : [messages];
        var oldMessages = this.conversation || [];
        this.conversation = sortBy(uniqBy(__spread(oldMessages, newMessages), 'id'), 'id');
    };
    MessagingModule.prototype.reset = function () {
        this.conversation = [];
    };
    return MessagingModule;
}(Resource));
export default MessagingModule;
//# sourceMappingURL=messages.js.map